import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataserviceService } from 'src/app/dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-dish-review',
  templateUrl: './dish-review.component.html',
  styleUrl: './dish-review.component.css'
})
export class DishReviewComponent {
  @Input() fullData: any;
  @Output() reviewInfo = new EventEmitter<any>();

  pricing: any;
  loadingId: any;
  confirmButton: boolean = false;

  constructor(
    private data: DataserviceService,
    private message: NzMessageService
  ) { }

  ngOnInit() { 
    console.log(this.fullData);
    this.confirmButton = true;
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Getting work order info...', { nzDuration: 0 }).messageId;
    this.data.postDataNoBodyDotBody({ conversationId: this.fullData.conversationId, autopay: this.fullData.processingFee.autopay, paperless: this.fullData.processingFee.paperless }, 'dish/calculatePricing')
    .subscribe({
      next: (r: any) => {
        this.pricing = r.data.Response.PriceSelectionsResponse.PricingInformation.PricingCategory;
        console.log(this.pricing);
        this.confirmButton = false;
        this.message.remove(this.loadingId);
      },
      error: (err: any) => {
        console.error(err);
        this.confirmButton = false;
        this.message.remove(this.loadingId);
      }
    });
  }

  reviewAccepted() {
    this.confirmButton = true;
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Getting ready to finalize...', { nzDuration: 0 }).messageId;
    setTimeout(() => {
      this.message.remove(this.loadingId)
      this.reviewInfo.emit({ reviewData: this.pricing })
      this.confirmButton = false;
    }, 500)
  }

  formatDateForPipe(dateStr: string): Date | null {
    if (!dateStr) return null;
  
    const [day, month, year] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  formatTime(time: string): string {
    let [hour, minute] = time.split(':').map(Number);
  
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;
  
    return `${hour}:${minute.toString().padStart(2, '0')} ${ampm}`;
  }

}
